<template>
  <div class="yesTea">
    <div class="g-box">
      <div class="yesTea-ban">
        <div class="yesTea-ban-left">
          <div class="hd">
            <div class="cap">{{ info.name }}</div>
            <div class="tit">{{ info.station }}</div>
          </div>
          <div class="text">
            <p v-if="info.stature">身高：{{ info.stature }}</p>
            <p v-if="info.constellation">星座：{{ info.constellation }}</p>
            <p v-if="info.home">家乡：{{ info.home }}</p>
            <p v-if="info.hobby">爱好：{{ info.hobby }}</p>
            <p v-if="info.school">院校：{{ info.school }}</p>
          </div>
          <div class="btn m-h" @click="$refs['RecList'].show()">
            和他/她成为同事
          </div>
        </div>
        <div
          class="yesTea-ban-right"
          :style="{
            backgroundImage: 'url(' + info.image + ')'
          }"
        ></div>
      </div>
      <div class="yesTea-list">
        <!--        <div class="list-hd">个人经历</div>-->
        <div class="list-text" v-html="info.experiences"></div>
        <!--        <template v-if="info.interview">-->
        <!--          <div class="list-hd">真人采访</div>-->
        <!--          <div class="list-text" v-html="info.interview"></div>-->
        <!--        </template>-->
      </div>
      <RecList ref="RecList" />
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../mixins/pageMain_mx";
import RecList from "../../components/RecList";

export default {
  mixins: [pageMain_mx],
  data() {
    return {
      info: {}
    };
  },
  components: { RecList },
  mounted() {},
  methods: {
    init() {
      this.$api.cms.web.coworker_details
        .get({
          id: this.params.id
        })
        .then(res => {
          this.info = res.data;
        });
    }
  }
};
</script>
<style lang="less">
.yesTea {
  padding: 105px 0;
}
.yesTea-ban {
  display: flex;
  background: rgba(242, 243, 247, 1);
}
.yesTea-ban-left {
  width: 564px;
  flex-shrink: 0;
  box-sizing: border-box;
  padding: 60px 0 30px 100px;
  .hd {
    display: flex;
    align-items: flex-end;
    line-height: 1;
  }
  .cap {
    color: #282828;
    font-size: 24px;
  }
  .tit {
    color: #979797;
    font-size: 16px;
    margin-left: 16px;
  }
  .text {
    color: #979797;
    font-size: 16px;
    margin-top: 40px;
    line-height: 1.8;
  }
  .btn {
    color: #ffffff;
    font-size: 16px;
    text-align: center;
    width: 180px;
    height: 36px;
    line-height: 36px;
    background: rgba(253, 143, 93, 1);
    margin-top: 40px;
  }
}
.yesTea-ban-right {
  flex-grow: 1;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  min-height: 424px;
}
.yesTea-list {
  .list-hd {
    color: #282828;
    font-size: 20px;
    padding-left: 24px;
    position: relative;
    margin-top: 80px;
    &:after {
      content: "";
      position: absolute;
      left: 0;
      top: 50%;
      margin-top: -8px;
      width: 4px;
      height: 16px;
      background: rgba(82, 151, 224, 1);
    }
  }
  .list-text {
    font-size: 16px;
    line-height: 32px;
    margin-top: 32px;
  }
}
</style>
